import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import useGetUserData from "../api/userMe"; // This is a hook that returns a function

const useUserData = () => {
  const [userData, setUserData] = useState(null);
  const { token } = useAuth();
  const getUserData = useGetUserData(); // Call the hook at the top level

  useEffect(() => {
    if (!token) {
      console.log("No token found");
      setUserData(null);
      return;
    }
    
    async function fetchUserData() {
      console.log("Fetching user role...");
      try {
        const data = await getUserData(token);
        console.log("User:", data);
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user role: ", error);
        setUserData(null);
      }
    }
    
    fetchUserData();
  }, 
  [token, getUserData]
);

  return userData;
};

export default useUserData;